import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Fragrances from "./pages/Fragrances";
import Gifts from "./pages/Cart";
import BestSales from "./pages/BestSales";
import Find from "./pages/Find";
import Index from "./dashboard/Index";
import Overview from "./dashboard/pages/Overview";
import Product from "./dashboard/pages/Products/Product";
import Pages from "./dashboard/pages/Pages";
import Contact from "./dashboard/pages/Contact";
import Faqs from "./dashboard/pages/Faqs";
import Category from "./dashboard/pages/Products/Category";
import Create from "./dashboard/pages/Products/Create";
import Users from "./dashboard/pages/Users";
import Orders from "./dashboard/pages/Orders";
import Cart from "./pages/Cart";
import Favorites from "./pages/Favorite";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "./redux/api/products"; // ✅ getProducts hata diya
import ProductDetails from "./pages/ProductDetails";
import Checkout from "./pages/Checkout";
import Auth from "./pages/Auth";
import Profile from "./pages/Profile";
import UserProfile from "./components/user-dashboard/UserProfile";
import Terms from "./pages/Terms";
import Return from "./pages/Return";
import Privacy from "./pages/Privacy";
import { setProducts } from "./redux/store/productSlice";
import api from "./utilis/api";
import Wishlist from "./components/user-dashboard/Wishlist";
import Address from "./components/user-dashboard/Address";
import Myorder from "./components/user-dashboard/Myorder";
import CardDetailForm from "./components/user-dashboard/Card";
import { isTokenExpired } from "./utilis/auth";
import { logout } from "./redux/store/userSlice";
import PrivateRoute from "./components/PrivateRoutes";
import Payment from "./pages/Payment";
import OrderDetail from "./components/user-dashboard/OrderDetail";
import { useLoading } from "./utilis/LoadingContext";
import Loader from "./components/Loader";
import { setLoadingSetter } from "./utilis/loadingHelper";
import ForgetPasswrod from "./pages/ForgetPasswrod";
import ScrollToTop from "./utilis/Scroll";
import Testimonial from "./dashboard/pages/Testimonial";
import WhatsAppButton from "./components/WhatsAppButton";
import Vendors from "./dashboard/pages/Vendors";
import AdminRoute from "./utilis/adminRoute";
import Success from "./pages/Success";

const App = () => {
  const { loading, setLoading } = useLoading();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token) || "";

  // ✅ fetchProducts dispatch ho raha hai
  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  useEffect(() => {
    if (!token || isTokenExpired(token)) {
      dispatch(logout());
    }
  }, [token, dispatch]);

  // expose setLoading to api.js
  setLoadingSetter(setLoading);

  return (
    <>
      {/* {loading && <Loader />} */}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/fragrance" element={<Fragrances />} />
        <Route path="/fragrance/:category" element={<Fragrances />} />
        <Route path="/contact" element={<Find />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route
          path="/product_description/:id"
          element={<ProductDetails key={location.key} />}
        />
        <Route path="/return_policy" element={<Return />} />
        <Route path="/privacy_policy" element={<Privacy />} />
        <Route path="/terms_conditions" element={<Terms />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/success" element={<Success />} />
        {/* Admin Dashboard */}
        <Route
          path="/dashboard"
          element={
            <AdminRoute>
              <Index />
            </AdminRoute>
          }
        >
          <Route index element={<Pages />} />
          <Route path="pages" element={<Pages />} />
          <Route path="contact" element={<Contact />} />
          <Route path="faqs" element={<Faqs />} />
          <Route path="testimonial" element={<Testimonial />} />
          <Route path="categories" element={<Category />} />
          <Route path="create-products" element={<Create />} />
          <Route path="products" element={<Product />} />
          <Route path="users" element={<Users />} />
          <Route path="orders" element={<Orders />} />
          <Route path="subscribe" element={<Orders />} />
          <Route path="vendors" element={<Vendors />} />
        </Route>

        {/* Auth Pages */}
        <Route path="/auth" element={<Auth />} />
        <Route path="/forget-password" element={<ForgetPasswrod />} />

        {/* User Profile */}
        <Route
          path="/user"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        >
          <Route index element={<UserProfile />} />
          <Route path="profile" element={<UserProfile />} />
          <Route path="favorite" element={<Wishlist />} />
          <Route path="address" element={<Address />} />
          <Route path="order_history" element={<Myorder />} />
          <Route path="order_detail/:id" element={<OrderDetail />} />
          <Route path="card" element={<CardDetailForm />} />
        </Route>
      </Routes>

      <WhatsAppButton />
    </>
  );
};

export default App;
